import { Directive } from '@angular/core';

/**
 * Directive used by {@link TsSidenavComponent} to select passed-in panel contents
 */
@Directive({ selector: '[tsTriggerComponentPanelContent]' })
export class TsTriggerComponentPanelContentDirective {}
